import { createContext } from 'react'
import type { AccountContext as AccountContextType } from '@/types'

export interface AccountContextValue {
  account: AccountContextType | null
  isLoading: boolean
  error: string | null
  /**
   * Native customer app (app/): resolve the account from the authenticated
   * session after a lease-code login. No-op inside LINE, where the account is
   * resolved pre-login from the ambient liff_id.
   */
  reloadAccount: () => Promise<void>
}

export const AccountCtx = createContext<AccountContextValue | undefined>(undefined)
